import { css } from '@emotion/react';

import { flex } from 'src/styles/utils';
import { InitialLoadIconsSet } from 'src/utils/constants/IconsConstants';

import { getInitialLoadIcons, ZeeFontMedium } from '../../../styles/font';
import { MediaBP as MQ } from '../../../styles/mediaQuery';

export const railsTitle = css`
  margin: 16px 10px 16px 0;
  ${ZeeFontMedium(16)}
  ${MQ.MediaLg} {
    ${ZeeFontMedium(21)}
  }
`;
export const railsContainer = css`
  width: 100%;
  padding-bottom: 16px;
  display: inline-block;
  ${MQ.MediaLg} {
    &:hover {
      & .arrow-btn {
        opacity: 1;
        z-index: 100;
      }
    }
  }
`;

export const railsHeaderStyle = css`
  ${flex('row', 'space-between')};
`;

export const moreLinkStyle = css`
  ${ZeeFontMedium(14, 16)};
  ${getInitialLoadIcons(InitialLoadIconsSet.VIEW_ALL, true)};
  margin: 0px;
  &:after {
    margin-left: 5px;
  }
`;

export const exploreNowContainer = css`
  width: 100%;
`;

export const exploreNowWrapper = css`
  gap: 10px;
  ${flex('row', 'flex-start')};
  flex-wrap: wrap;
`;

export const thumbnailImageStyle = (hideMenu: boolean) => css`
  flex: 0 0 calc(32% - 2px);
  ${MQ.MediaSm} {
    flex: 0 0 calc(32%);
  }
  ${MQ.MediaMd} {
    flex: 0 0 calc(24%);
  }
  ${MQ.MediaLg} {
    ${hideMenu ? `flex: 0 0 calc(12% - 4px)` : `flex: 0 0 calc(33% - 5px)`};
  }
  &:hover {
    transform: scale3d(1.05, 1.05, 1) translate3d(0, 0, 0);
    transition: transform 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
  }
`;
